export default __webpack_public_path__ + "static/media/bees.0dcd26eb.png";